/**
 * LiteModeToggle - Toggle switch for Lite/Modern animation mode
 * 
 * Positioned in hero section, allows users to:
 * - Switch between Modern (full animations) and Lite (reduced animations) modes
 * - Override auto-detected settings
 */
import { useLiteMode } from '@/context/LiteModeContext';
import { Sparkles, Zap } from 'lucide-react';
import './LiteModeToggle.css';

const LiteModeToggle = () => {
  const { isLiteMode, setLiteMode, isAutoDetected } = useLiteMode();

  const handleToggle = () => {
    setLiteMode(!isLiteMode);
  };

  return (
    <div className="lite-mode-toggle-container">
      {/* WCAG 2.5.3 (Label in Name): the accessible name must contain the
          visible label ("Lite" / "Modern") so voice control can target it. */}
      <button
        className={`lite-mode-toggle ${isLiteMode ? 'lite' : 'modern'}`}
        onClick={handleToggle}
        aria-label={isLiteMode ? 'Lite mode on — switch to Modern mode (more animations)' : 'Modern mode on — switch to Lite mode (reduced animations)'}
        title={isAutoDetected ? 'Auto-detected based on your device - click to override' : 'Toggle animation mode'}
      >
        <span className="toggle-track">
          <span className="toggle-thumb">
            {isLiteMode ? (
              <Zap size={10} strokeWidth={2.5} />
            ) : (
              <Sparkles size={10} strokeWidth={2.5} />
            )}
          </span>
        </span>
        <span className="toggle-label">
          {isLiteMode ? 'Lite' : 'Modern'}
        </span>
      </button>
      {isAutoDetected && (
        <span className="auto-badge" title="Automatically enabled based on your device settings">
          Auto
        </span>
      )}
    </div>
  );
};

export default LiteModeToggle;
